import React, { memo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { motion, AnimatePresence } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import '../styling/InfoSlider.css'

const InfoSlider = memo(({ isOpen, onClose, title, description, features }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <AnimatePresence>
      <div
        className='info-slider-overlay'
        onClick={onClose}
        role='dialog'
        aria-modal='true'
        aria-labelledby='info-slider-title'
      >
        <motion.div
          className='info-slider'
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'spring', damping: 20 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className='info-slider-header'>
            <h2 id='info-slider-title'>{title}</h2>
            <button className='close-button' onClick={onClose} aria-label='Close information panel'>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className='info-slider-content'>
            <p className='description' style={{ color: '#000!important', textAlign: 'left' }}>
              {description}
            </p>

            {features && features.length > 0 && (
              <div className='features-list'>
                <h3>Key Features</h3>
                <ul>
                  {features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  )
})

InfoSlider.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string)
}

InfoSlider.displayName = 'InfoSlider'

export default InfoSlider
